import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import { ImpactMapList } from '../';

class ClientDetails extends React.Component {
  constructor(props) {
    super(props);
  }
  componentWillMount() {
    !(this.props.fields['Client']) ? this.props.fetchFields('Client') : '';
      this.props.joinSocketChannel(this.props.client._id);
  }
  componentWillUpdate(nextProps, nextState) {
    if(
      nextProps.client &&
      nextProps.client._id &&
      this.props.client._id != nextProps.client._id
    ) {
      this.props.leaveSocketChannel(this.props.client._id);
      this.props.joinSocketChannel(nextProps.client._id);
    }
  }
  componentWillUnmount() {
    this.props.leaveSocketChannel(this.props.client._id);
  }

  render() {
    if(!this.props.client || !this.props.client._id) {
      return <noscript />
    }
    const { address, name, phone, last_updated, owners, owner, owner_account, _id, date_added } = this.props.client;
    const { user, clients, simple, fields } = this.props;

    const longitude = address ? address.feature ? address.feature.geometry.coordinates[0] : 0 : 0;
    const latitude = address ? address.feature ? address.feature.geometry.coordinates[1] : 0 : 0;
    const apiKey = 'AIzaSyCWuH5SGDikY4OPSrbJxqTi4Y2uTgQUggw';
    const pitch = -18.26;
    const heading = null;
    const fullAddress =
      !address || (!address.street && !address.city && !address.state && !address.zip) ? null :
      `${ address && address.street ? `${address.street},` : ''}
      ${ address && address.city ? address.city : '' }
      ${ address && address.state? address.state : '' }
      ${ address && address.zip ? address.zip : '' }`;
    const googleImage = `${'https://'}maps.googleapis.com/maps/api/streetview?size=600x400&fov=110&location=${latitude},${longitude}&heading=${heading}&pitch=${pitch}&key=${apiKey}`;
    const createdDate = moment(date_added);
    const lastEdited = moment(last_updated);

    const permissions = [
      {
        name : 'View',
        className : 'fa fa-eye',
        access : owners ? (owners.find(owner => (owner._id == user._id)) ? true : false) || owner_account == user.owner_account : false
      }, {
        name : 'Edit',
        className : 'fa fa-pencil',
        access : owner ? user._id == owner._id || owners.find(owner => (owner._id == user._id)) : false
      }, {
        name : 'Assign',
        className : 'fa fa-chain',
        access : owners ? owners.find(owner => (owner._id == user._id)) ? true : false : false
      }
    ].filter(({access}) => (access));
    if(clients.fetching_client) {
      return <section className="panel animated fadeInDown">
        <div className="panel-body">
          <div className="text-center"><i className="fa fa-spinner fa-spin fa-1x fa fw"></i></div>
        </div>
      </section>
    }
    return (
      <section className="animated fadeInDown client-details-container">
	        <div className="thumb-info mb-md">
	          <img src={googleImage} className="rounded img-responsive" alt="John Doe"/>
	          <div className="thumb-info-title">
	            <span className="thumb-info-inner">{name}</span>
	            {fullAddress ? <span className="thumb-info-type"><i className="fa fa-home"></i> { fullAddress }</span> : null}
	          </div>
	        </div>
	        <h4 className="text-muted">Details</h4>
	        <hr className='short'/>
	        <ul className="list-unstyled">
	          <li><i className="fa fa-phone"></i> <span className="text-weight-bold">Phone: </span> {phone || 'None.'} </li>
	          <li><i className="fa fa-home"></i> <span className="text-weight-bold">Address:</span> {address.street || 'None.'}</li>
	          <li>
	            <ul className="list-inline">
	              <li><i className="fa fa-globe"></i> <span className="text-weight-bold">City: </span> {address.city || 'None.'} </li>
	              <li><span className="text-weight-bold">State: </span> {address.state || 'None.'}</li>
	              <li><span className="text-weight-bold">Zip: </span> {address.zip || 'None.'}</li>
	            </ul>
	          </li>
            {fields.map(field => {
              const value = this.props.client[field.name];
              return <li key={field._id}><span className="text-weight-bold"><i className="fa fa-info"></i> {field.label}:</span> {value || 'None.'}</li>

            })}
            <li><i className="fa fa-calendar"></i> <strong>Created: </strong> { createdDate.fromNow()  } <small className="text-muted"> ({createdDate.format('YYYY-MM-DD')}) </small></li>
	          {user.creator ? <li><i className="fa fa-user"></i> <strong>Creator: </strong> {`${creator.name.first} ${creator.name.last}`} </li> : ''}

	        </ul>
	        {!simple ? (
	        <div>
	          <h4 className="text-muted">Permissions</h4>
	          <hr className='short'/>
	          {permissions.length > 0 ? <ul className="list-inline">
	            <li><i className="fa fa-key"></i> <span className="text-weight-bold">Access: </span></li>
	            {permissions.map(({className, name}, idx) => <li key={idx}><i className={className}></i> {name}</li>)}
	          </ul> : ''}
	          <ul className="list-inline">
	            {owners.length == 1 && owner.name ? <li><i className="fa fa-users"></i> <span className="text-weight-bold">Owner: </span> {`${owner.name.first} ${owner.name.last} (${owner.role})`}</li> : ''}
              {owners.length > 1 ? <li><i className="fa fa-users"></i> <span className="text-weight-bold">Owners: </span>
              {owners.map((current_owner, index) => {
                  return (
                    <span key={current_owner._id} className="">
                      <i className="fa fa-user"></i>
                      {`${current_owner.name ? current_owner.name.first || '' : ''} ${current_owner.name ? current_owner.name.last || '' : ''} (${current_owner.role})${owners.length - 1 != index ? ', ':''}`}
                    </span>
                  )
                })}
              </li> : ''}
	          </ul>
	        </div>
	        ) : ''}
	        <hr className='short'/>
	        <div className="clearfix">
	          <span className="text-uppercase text-muted pull-left">
	             <strong><i className="fa fa-history"></i> LAST UPDATED: </strong> { lastEdited.fromNow() } <small className="text-muted"> ({createdDate.format('YYYY-MM-DD')}) </small>
	          </span>
	        </div>
	        <hr className='short'/>
	        {this.props.children}
          <ImpactMapList onViewMap={this.props.onViewMap} coords={latitude && longitude? ({lat: latitude, lng:longitude}) : undefined} />
      </section>
    );
  }
}

ClientDetails.propTypes = {
  simple : PropTypes.bool,
  onViewMap: PropTypes.func,
}

const mapStateToProps = ({connection, clients, fields}) => ({
  user : connection.user,
  clients,
  fields: (fields['Client'] || [])
    .filter(({show_with_details}) => show_with_details)
    .sort((a,b) => {
      return (a.order || 0) - (b.order || 0);
    })
});

export default connect(mapStateToProps, Actions)(ClientDetails);



// WEBPACK FOOTER //
// ./src/browser/components/client/client-details.js